import { ChevronDown, LayoutGrid, Menu, ReceiptText, Settings, Wallet } from "lucide-react";
import type { Owner } from "../types";
import { moreSubviews, type View } from "./views";
import Avatar from "../components/Avatar";
import Brand from "../components/Brand";
import type { BrandEnvironment } from "../lib/branding";

// The two ways around the app: the sidebar on wide screens and the bottom bar on phones. "More"
// stays highlighted while any screen reached from it is open.

export function Sidebar({ environment, view, nav, appVersion, profile, onOpenProfile }: {
  environment?: BrandEnvironment;
  view: View;
  nav: (view: View) => void;
  appVersion: string;
  profile: Owner;
  onOpenProfile: () => void;
}) {
  return (
    <aside className="sidebar">
      <Brand environment={environment} />
      <p className="sidebar-caption">THE HOUSEHOLD</p>
      <nav>
        {(
          [
            ["overview", LayoutGrid, "Overview"],
            ["accounts", Wallet, "Accounts"],
            ["transactions", ReceiptText, "Transactions"],
            ["more", Menu, "More"],
            ["settings", Settings, "Settings"],
          ] as const
        ).map(([v, I, label]) => (
          <button
            key={v}
            className={view === v || (v === "more" && moreSubviews.includes(view)) ? "active" : ""}
            onClick={() => nav(v)}
            aria-current={view === v ? "page" : undefined}
          >
            <I size={20} />
            {label}
          </button>
        ))}
      </nav>
      <div className="sidebar-footer">
        <span className="connection-dot" />
        Connected
        <p>Everything in its place.</p>
        <small>{appVersion}</small>
      </div>
      <button
        className="sidebar-profile"
        onClick={onOpenProfile}
      >
        <Avatar owner={profile} size={36} />
        <span>
          {profile}
          <small>Your profile</small>
        </span>
        <ChevronDown size={17} />
      </button>
    </aside>
  );
}

export function BottomNav({ view, nav }: { view: View; nav: (view: View) => void }) {
  return (
    <nav className="bottom-nav" aria-label="Main navigation">
      {(
        [
          ["overview", LayoutGrid, "Overview"],
          ["accounts", Wallet, "Accounts"],
          ["transactions", ReceiptText, "Transactions"],
          ["more", Menu, "More"],
        ] as const
      ).map(([v, I, label]) => (
        <button
          key={v}
          className={
            view === v || (v === "more" && moreSubviews.includes(view))
              ? "active"
              : ""
          }
          onClick={() => nav(v)}
          aria-current={view === v ? "page" : undefined}
        >
          <I size={21} />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
}
